import { Routes } from "@angular/router";

import { LoginComponent } from "./components/login/login.component";
import { LogoutComponent } from "./components/logout/logout.component";
import { OauthCallbackComponent } from "./components/oauth-callback/oauth-callback.component";
import { GuestGuard } from "../shared/guards/guest.guard";
import { LoggedInGuard } from "../shared/guards/loggedin.guard";

export const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "login",
        component: LoginComponent,
        canActivate: [GuestGuard],
      },
      {
        path: "logout",
        component: LogoutComponent,
        canActivate: [LoggedInGuard],
      },
      {
        path: "oauth-callback",
        component: OauthCallbackComponent,
      },
      {
        path: "",
        component: LoginComponent,
        canActivate: [GuestGuard],
      },
    ],
  },
];
